import { take, call, put } from "redux-saga/effects";
import { padRootUrl, callServer } from "~/api/call-server";
import { handleErrorSaga } from "~/store/sagas/error-handling-saga";
import { IGetReturnCodeRequest } from "~/store/reducers/return-code/return-code-actions";
import { ReturnCodeActionTypes } from "~/store/reducers/return-code/return-code-types";

function* getReturnCode({ apiUrl, reject, resolve, data }: IGetReturnCodeRequest) {
    try {
        const response = yield call(callServer, padRootUrl(apiUrl), "post", data);
        yield put({
            type: ReturnCodeActionTypes.GET_RETURN_CODE_SUCCESS,
            payload: response.payload
        });
        yield call(resolve);
    } catch (error) {
        yield call(handleErrorSaga, error, reject);
    }
}

export default function* returnCodeSaga() {
    while (true) {
        const action = yield take([ReturnCodeActionTypes.GET_RETURN_CODE_REQUEST]);

        if (action.type === ReturnCodeActionTypes.GET_RETURN_CODE_REQUEST) {
            yield call(getReturnCode, action.payload);
        }
    }
}
